export default "__VITE_ASSET__CrKW5p_Z__"